<template>
  <TransitionGroup
    name="list"
    tag="div"
    :class="easyNotificationsBem()"
    data-cy="wrapper__easy-notifications"
  >
    <EasyNotification
      v-for="notification in easyNotificationsStore.notifications.value"
      :key="notification.id"
      v-bind="notification"
    />
  </TransitionGroup>
</template>

<script setup lang="ts">
import EasyNotification from "@/src/easy-ui/components/easyNotifications/EasyNotification.vue";
import easyNotificationsStore from "@/src/easy-ui/store/easyNotificationsStore";
import { easyNotificationsBem } from "@/src/easy-ui/utils/easyNotifications";
</script>

<style lang="scss">
@use "../../../shared/stylesheets/easy/utils/helpers/functions/index" as *;
@use "../../../shared/stylesheets/easy/variables/index" as *;

#easy-notifications {
  position: fixed;
  top: px(40);
  right: px(40);

  z-index: z($z-priority, tooltip);

  .easy-notifications {
    display: flex;
    flex-direction: column;
    row-gap: px(8);
    align-items: flex-end;

    .list-enter-active,
    .list-leave-active {
      transition: all 0.5s ease;
    }

    .list-enter-from,
    .list-leave-to {
      opacity: 0;
      transform: translateX(px(1000));
    }
  }
}
</style>
